<template>
  <!-- <tr>
    <td class="koumoku claimCont cwC_1">
      <vSelect
        :options="opType"
        v-model="item.c_report_det_type"
        :reduce="(label:any) => label.code"
      ></vSelect>
    </td>
    <td class="suuryou claimCont cwC_2">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_project_name"
      />
    </td>
    <td class="suuryou claimCont cwC_3">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_visited_name"
      />
    </td>
    <td class="tanka claimCont cwC_4">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_location"
      />
    </td>
    <td class="kingaku claimCont cwC_5">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_work_contents"
      />
    </td>
    <td class="syouhizei claimCont cwC_6 selectedClear selectBorderNone">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_sales"
      />
    </td>
    <td class="zeikomi claimCont cwC_7">
      <input
        type="text"
        style="text-align: right"
        class=""
        v-model="item.c_report_det_supply"
      />
    </td>
  </tr> -->
  <tr>
    <td class="reportCont cwC_1">
      <!-- <input type="text" class="" v-model="item.c_report_det_type" /> -->
      {{ item.c_report_det_type_name }}
    </td>
    <td class="reportCont cwC_2">
      <!-- <input type="text" class="" v-model="item.c_report_det_project_name" /> -->
      {{ item.c_report_det_project_name }}
    </td>
    <td class="reportCont cwC_3">
      <!-- <input type="text" class="" v-model="item.c_report_det_visited_name" /> -->
      {{ item.c_report_det_visited_name }}
    </td>
    <td class="reportCont cwC_4">
      <!-- <input type="text" class="" v-model="item.c_report_det_location" /> -->
      {{ item.c_report_det_location }}
    </td>
    <td class="reportCont cwC_5">
      <!-- <input type="text" class="" v-model="item.c_report_det_work_contents" /> -->
      {{ item.c_report_det_work_contents }}
    </td>
    <td class="reportCont cwC_6">
      <!-- <input type="text" class="" v-model="item.c_report_det_sales" /> -->
      {{ item.c_report_det_sales }}
    </td>
    <td class="reportCont cwC_7">
      <!-- <input type="text" class="" v-model="item.c_report_det_supply" /> -->
      {{ item.c_report_det_supply }}
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  CONST_OP_DAILYREPORT_TYPE,
  CONST_OP_TAXRATE,
} from "furukawa-common/src/common/constant/Constants";
import { EntityReportDet } from "furukawa-common/src/common/entity/EntityReportDet";
import { EntityReportDetImple } from "furukawa-common/src/common/entity/EntityReportDetImple";

@Options({
  components: {
    vSelect,
  },
})
export default class Mo_tableReportList_det extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityReportDetImple;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------

  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  // async mounted() {}

  //----------------------
  //基本操作用メソッド
  //----------------------

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
td {
  border-left: 1px solid #dfdfdf;
}
.cwC_6 {
  border-right: 1px solid #dfdfdf;
}
.claimCont > input,
.claimCont > select {
  width: 100%;
  height: 30px;
  border: none;
}

.cwC_1 {
  text-align: center;
}
.cwC_2 {
}
.cwC_3 {
}
.cwC_4 {
}
.cwC_5 {
}
.cwC_6 {
}
.cwC_7 {
}
</style>
